import React from 'react';
import { Checkbox } from '@base-ui/react/checkbox';
import styles from './CampoCheckbox.module.css';

type Props = {
  label?: string;
  children?: React.ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  instanceId?: string;
  size?: 'small' | 'medium' | 'large';
  [key: string]: any;
};

const CampoCheckbox = ({
  label,
  children,
  value,
  onChange,
  disabled,
  instanceId,
  size = 'medium',
  ...props
}: Readonly<Props>) => {
  return (
    <label className={[styles.container, disabled ? styles.disabled : null].filter(Boolean).join(' ')}>
      {label && <span className={styles.fieldLabel}>{label}</span>}
      <span className={styles.row}>
        <Checkbox.Root
          id={instanceId}
          checked={value ?? false}
          onCheckedChange={onChange}
          disabled={disabled}
          className={[
            styles.checkbox,
            styles[size],
          ].join(' ')}
        >
          <Checkbox.Indicator className={styles.indicator} />
        </Checkbox.Root>
        {children && (
          <span className={disabled ? styles.disabledText : undefined}>
            {children}
          </span>
        )}
      </span>
    </label>
  );
};

export default CampoCheckbox;
